import * as React from 'react';
import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Button, { shouldForwardProp: (prop) => prop !== 'loading' })(
	({ theme, loading }) => ({
		padding: loading ? '6px 23px' : '6px 34px',
		borderRadius: 20,
		border: `1px solid ${theme.palette.separator.primary}`,
		textTransform: 'none',
		'&:disabled': {
			color: theme.palette.text.secondary,
			opacity: 0.7
		}
	})
);

const ButtonLoader = styled(CircularProgress)(({ theme }) => ({
	width: '14px !important',
	height: '14px !important',
	color: theme.palette.text.secondary,
	marginLeft: 8
}));

export default function SecondaryButton({ ...props }) {
	const [loading, setLoading] = useState(false);

	/**
	 * Wraps the button function with loader states.
	 */
	const handleClick = async () => {
		setLoading(true);
		await props?.onClick();
		setLoading(false);
	};

	return (
		<Root disabled={loading} loading={loading} onClick={handleClick} {...props}>
			{props.children}
			{loading && <ButtonLoader />}
		</Root>
	);
}
